/* eslint-disable react/prop-types */
import React from 'react';
import numeral from 'numeral';
import { Link } from 'react-router-dom';

import { getRangeFromDays } from '../../utils/dates';
import { affinityReportMovies } from '../../config/filters';

export const config = {
  AFFINITY_REPORT_PAGE_ID: 'affinityReportMovies',
  AFFINITY_REPORT_FILTERS: affinityReportMovies
};

export const defaultSorts = ['affinityIndex'];

export const columns = [
  {
    Header: 'Movie',
    accessor: 'movie',
    className: 'tvt-tabular-data-table__show-affinity-show',
    Cell: ({ row: { original }, cell: { value } }) => (
      <Link to={`/movie/${original.movieId}`}>{value}</Link>
    )
  },
  {
    Header: 'Studio',
    accessor: 'studio',
    className: 'tvt-tabular-data-table__show-affinity-network'
    // Cell: ({ row: { original }, cell: { value } }) => (
    //   <Link to={`/network/${original.networkId}`}>{value}</Link>
    // )
  },
  {
    Header: 'Overlapping Viewers',
    accessor: 'overlappingViewers',
    Cell: ({ cell: { value } }) => numeral(value).format('0,0'),
    className:
      'tvt-tabular-data-table__td-kpi tvt-tabular-data-table__show-affinity-overlappingViewers caret-center',
    sortDescFirst: true
  },
  {
    Header: 'Affinity Index',
    accessor: 'affinityIndex',
    // Cell: ({ cell: { value } }) => numeral(value).format('0,0'),
    className:
      'tvt-tabular-data-table__td-kpi tvt-tabular-data-table__show-affinity-affinityIndex caret-center',
    sortDescFirst: true,
    Cell: ({ cell: { value } }) => numeral(value).format('0'),

    hoverTitle:
      'Measure of target (show, movie, character) audience interest relative to another target (show, movie, character) in the overall population. We display an Affinity Index for followers to viewers, actor voters to actor voters, and viewers to viewers. This index is normalized to a score of 100'
  }
];

export const affinityFilters = {
  content: [
    {
      id: 'movie',
      label: 'Movie',
      tooltip:
        "Selecting multiple movies with ‘AND' will include viewers who watched ALL the movies selected (a smaller audience than a single movie). \n Selecting multiple movies with ‘OR' will include viewers who watched ANY of the movies selected (a larger audience than a single movie)."
    }
  ],
  demographic: [
    { id: 'age', label: 'Age Range' },
    { id: 'country', label: 'Region' },
    {
      id: 'gender',
      label: 'Gender',
      isToggle: true,
      options: [
        { value: null, label: 'All' },
        { value: 'female', label: 'Female' },
        { value: 'male', label: 'Male' }
      ]
    },
    {
      id: 'panel',
      label: 'Panel',
      isToggle: true,
      options: [
        { value: null, label: 'Total' },
        { value: 'Yes', label: 'Balanced' }
      ]
    }
  ],
  date: [
    {
      id: 'date',
      label: 'Date Range',
      isToggle: true,
      options: [
        { value: null, label: 'All Time' },
        { value: getRangeFromDays(30).value, label: 'Last 30 days' },
        { value: getRangeFromDays(60).value, label: 'Last 60 days' },
        { value: getRangeFromDays(90).value, label: 'Last 90 days' },
        { value: -1, label: 'Custom', id: 'custom-date' }
      ]
    }
  ]
};
